// extracted by mini-css-extract-plugin
export var attachment = "_oq-a";
export var emailContainer = "_oq-4";
export var emailContentPaddedContainer = "_oq-b";
export var emailHeader = "_oq-6";
export var emailIframe = "_oq-3";
export var emailInfoIcon = "_oq-9";
export var emailShortenedSummary = "_oq-e";
export var infoDropdown = "_oq-0";
export var infoRowBoundedContent = "_oq-d";
export var internal = "_oq-5";
export var merchant = "_oq-8";
export var messageInputContainer = "_oq-h";
export var normal = "_oq-7";
export var replyCard = "_oq-f";
export var subtleButton = "_oq-1";
export var subtleButtonIconContainer = "_oq-2";
export var toggleViewRepliesButton = "_oq-c";
export var wrappingText = "_oq-g";